<script setup lang="ts">
import { checkboxGroupProps } from 'naive-ui';

const props = defineProps(checkboxGroupProps);
</script>

<template>
  <!-- Themed n-checkbox-group: holds the shared value for a set of
       GaiaCheckboxes, so each child carries only its own `value`. Nothing to
       restyle here — the group draws no chrome of its own — but it stays a
       wrapper so a set of checkboxes never reaches for a raw n-* tag. -->
  <n-checkbox-group v-bind="props">
    <slot />
  </n-checkbox-group>
</template>
